const sources = [
    {
        name: 'computerSetupModel',
        type: 'gltfModel',
        path: 'models/Computer/computer_setup.glb',
    },
    {
        name: 'computerSetupTexture',
        type: 'texture',
        path: 'models/Computer/baked_computer.jpg',
    },
    {
        name: 'environmentModel',
        type: 'gltfModel',
        path: 'models/World/environment.glb',
    },
    {
        name: 'environmentTexture',
        type: 'texture',
        path: 'models/World/baked_environment.jpg',
    },
    {
        // Siege baquet repris de la scene de reference du dossier 1
        // (my-room-in-3d). Le modele etait compresse en Draco ; il est
        // decompresse ici pour ne pas avoir a embarquer le decodeur.
        name: 'gamerChairModel',
        type: 'gltfModel',
        path: 'models/GamerChair/gamer_chair.glb',
    },
    {
        // Mobilier et objets repris de la scene du dossier 1, extraits du
        // maillage unique de la piece. Un noeud nomme par objet, pour les
        // placer individuellement. Ni mur, ni sol, ni plafond.
        name: 'roomDecorModel',
        type: 'gltfModel',
        path: 'models/RoomDecor/room_decor.glb',
    },
    {
        // Poste de travail complet de la scene du dossier 1, extrait du
        // maillage unique de la piece : 71 objets, un noeud nomme chacun,
        // dans leur disposition d'origine. Partage l'atlas de cuisson avec
        // le siege et le reste du decor, donc aucune texture en plus.
        name: 'deskSetModel',
        type: 'gltfModel',
        path: 'models/RoomDecor/desk_set.glb',
    },
    {
        name: 'googleLedsModel',
        type: 'gltfModel',
        path: 'models/RoomLights/google_leds.glb',
    },
    {
        name: 'loupedeckModel',
        type: 'gltfModel',
        path: 'models/RoomLights/loupedeck.glb',
    },
    {
        // Atlas de cuisson du dossier 1, partage par la chaise et le decor :
        // un seul fichier pour tous ces objets. Reduit de 4096 a 2048 et
        // passe en webp (1415 ko -> 423 ko), rendu indiscernable a la taille
        // ou ces objets apparaissent (compare en 4096, 2048 et 1024).
        name: 'roomAtlasTexture',
        type: 'texture',
        path: 'models/RoomDecor/baked_room_atlas.webp',
    },
    {
        name: 'decorModel',
        type: 'gltfModel',
        path: 'models/Decor/decor.glb',
    },
    {
        name: 'decorTexture',
        type: 'texture',
        path: 'models/Decor/baked_decor_modified.jpg',
    },
    {
        name: 'monitorSmudgeTexture',
        type: 'texture',
        path: 'textures/monitor/layers/compressed/smudges.jpg',
    },
    {
        name: 'monitorShadowTexture',
        type: 'texture',
        path: 'textures/monitor/layers/compressed/shadow-compressed.png',
    },
    {
        name: 'mouseDown',
        type: 'audio',
        path: 'audio/mouse/mouse_down.mp3',
    },
    {
        name: 'mouseUp',
        type: 'audio',
        path: 'audio/mouse/mouse_up.mp3',
    },
    {
        name: 'keyboardKeydown1',
        type: 'audio',
        path: 'audio/keyboard/key_1.mp3',
    },
    {
        name: 'keyboardKeydown2',
        type: 'audio',
        path: 'audio/keyboard/key_2.mp3',
    },
    {
        name: 'keyboardKeydown3',
        type: 'audio',
        path: 'audio/keyboard/key_3.mp3',
    },
    {
        name: 'keyboardKeydown4',
        type: 'audio',
        path: 'audio/keyboard/key_4.mp3',
    },
    {
        name: 'keyboardKeydown5',
        type: 'audio',
        path: 'audio/keyboard/key_5.mp3',
    },
    {
        name: 'keyboardKeydown6',
        type: 'audio',
        path: 'audio/keyboard/key_6.mp3',
    },
    {
        name: 'startup',
        type: 'audio',
        path: 'audio/startup/startup.mp3',
    },
    {
        name: 'office',
        type: 'audio',
        // Use the ~288 KB .ogg instead of the 4.5 MB .mp3 — same ambience,
        // 15x lighter, so it never gates the scene from appearing.
        path: 'audio/atmosphere/office.ogg',
    },
    {
        name: 'ccType',
        type: 'audio',
        path: 'audio/cc/type.mp3',
    },
];
export default sources;
